import * as ReactDOMServer from 'react-dom/server';
import { useEffect, useState } from 'react'
import api from "../../../services/api";
import { Chart } from "react-google-charts";
import { format, subMonths } from 'date-fns';
import { LoadComponent, Text } from '../';
import { formatNumber } from '../../../helpers/number/numberFormat';
import { calculatePercentage } from '../../../helpers/number/numberPercentage';
import { useApp } from '../../../contexts';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import { translateText } from '../../../helpers/util';
import { getCoinCountryLabel } from '../../../helpers/util';

export const ComboChartMarketHistorySellPrices = ({ title = "", period = 12, officeId, comparativeUniverse, reloadTrigger }) => {

    const [officeMarketHistorySellPrices, setOfficeMarketHistorySellPrices] = useState([])
    const [officeHistorySellPrices, setOfficeHistorySellPrices] = useState([])
    const [historyData, setHistoryData] = useState([])
    const [options, setOptions] = useState({})
    const [load, setLoad] = useState(false)
    const { closeDialog, showDialog, language, translations, userCountry, buildingCountry } = useApp();

    useEffect(() => {
        if(comparativeUniverse !== null){
            loadHistorySellPrices()
        }
    }, [comparativeUniverse]);

    useEffect(() => {
        loadHistorySellPrices()
    }, [period, reloadTrigger]);

    const loadHistorySellPrices = async () => {
        try{
            setLoad(true)
            let url = `/office/${officeId}/history/sellprices?period=${period}`
            if(comparativeUniverse !== null){
                if(comparativeUniverse.classes.length > 0){
                    url+=`&buildingsClass=${comparativeUniverse.classes.join(',')}`
                }
                if(comparativeUniverse.profiles.length > 0){
                    url+=`&profiles=${comparativeUniverse.profiles.join(',')}`
                }
                if(comparativeUniverse.typeRegion == "radius"){
                    url+=`&radius=${comparativeUniverse.radius}`
                }
            }
            const response = await api.get(url)
            const { officeMarketHistorySellPrices, officeHistorySellPrices } = response.data
    
            setOfficeMarketHistorySellPrices(officeMarketHistorySellPrices)
            setOfficeHistorySellPrices(officeHistorySellPrices)
        }catch (error){
            console.log(error)
        }finally{
            setLoad(false)
        }
    }

    useEffect(() => {
        processData()
    }, [officeMarketHistorySellPrices, officeHistorySellPrices]);

    
    const processData = () => {

        // if (officeMarketHistorySellPrices.length > 0 && officeHistorySellPrices.length > 0) {
            const trimestres = [];
    
            for (let i = period; i >= 1; i--) {
                const strTrimestre = format(subMonths(new Date(), i * 3), "Q'T' yyyy");
                const ano = format(subMonths(new Date(), i * 3), "yyyy");
                const trimestre = format(subMonths(new Date(), i * 3), "Q");
                trimestres.push({ trimestre, ano, strTrimestre });
            }
            
            let historyData = [];
    
            let columns = [
                `${translateText("Trimestre", language, translations, userCountry)}`
            ]
    
            if (officeMarketHistorySellPrices.length > 0) {
                columns.push(`${translateText("Transações de Venda do Entorno", language, translations, userCountry)} (${getCoinCountryLabel(buildingCountry)}/m²)`)
                columns.push({ type: 'string', role: 'tooltip', p: { html: true } })
            }
    
            if (officeHistorySellPrices.length > 0) {
                columns.push(`${translateText("Transações de Venda do Edifício", language, translations, userCountry)} (${getCoinCountryLabel(buildingCountry)}/m²)`)
                columns.push({ type: 'string', role: 'tooltip', p: { html: true } })
            }
    
            historyData.push(columns)
    
    
            trimestres.forEach((trimestre, index) => {
    
                const quarterRegion = officeMarketHistorySellPrices.filter(item => item.ano == trimestre.ano && item.trimestre == trimestre.trimestre)
                const quarterBuilding = officeHistorySellPrices.filter(item => item.ano == trimestre.ano && item.trimestre == trimestre.trimestre)
    
                let quarterData = [
                    trimestre.strTrimestre
                ]
    
                if (officeMarketHistorySellPrices.length > 0) {
                    quarterData.push(quarterRegion.length > 0 ? Number(quarterRegion[0].vmve) : null)
                    quarterData.push(quarterRegion.length > 0 ? getOfficeMarketHistorySellPricesTooltip({ quarterRegion }) : '')
                }
    
    
                if (officeHistorySellPrices.length > 0) {
                    quarterData.push(quarterBuilding.length > 0 ? Number(quarterBuilding[0].vmve) : null)
                    quarterData.push(quarterBuilding.length > 0 ? getOfficeHistorySellPricesTooltip({ quarterBuilding }) : '')
                }
    
                historyData.push(quarterData)
            });
    
            let marketSellPricesActive = officeMarketHistorySellPrices.length > 0
            let sellPricesActive = officeHistorySellPrices.length > 0
    
            let series = {}
    
            if (marketSellPricesActive) {
                series[Object.keys(series).length] = { type: 'scatter', pointSize: 8, color: '#80bf8e' }
            }
    
            if (sellPricesActive) {
                series[Object.keys(series).length] = { type: 'scatter', pointSize: 18, pointShape: 'star', color: '#35553c' }
            }
        
            const valuesMinMax = [];

            if(officeHistorySellPrices.length > 0){
                valuesMinMax.push(getMinValue(officeHistorySellPrices));
                valuesMinMax.push(getMaxValue(officeHistorySellPrices));
            }

            if(officeMarketHistorySellPrices.length > 0){
                valuesMinMax.push(getMinValue(officeMarketHistorySellPrices));
                valuesMinMax.push(getMaxValue(officeMarketHistorySellPrices));
            }
    
            let minValue = null;
            let maxValue = null;
            if(valuesMinMax.length > 0){
                minValue = Math.min.apply(Math, valuesMinMax);
                maxValue = Math.max.apply(Math, valuesMinMax);
            }

           
            const options = {
                legend: { position: 'bottom', maxLines: 2, alignment: 'middle' },
                colors: ['#568C62'],
                chartArea: {
                    width: '100%',
                    left: 50,
                },
                // hAxis: { slantedText: true },
                vAxis: { 
                    viewWindow: {}
                },
                backgroundColor: {
                    'fill': 'transparent'
                },
                tooltip: { isHtml: true },
                isStacked: true,
                seriesType: 'bars',
                series,
            };

            if(minValue !== null){
                options.vAxis.viewWindow.min = minValue - calculatePercentage(10, minValue);
            }
            if(maxValue !== null){
                options.vAxis.viewWindow.max = maxValue + calculatePercentage(10, minValue);
            }

            if (historyData[0].length > 1) {
                setHistoryData(historyData)
                setOptions(options)
            }else{
                setHistoryData([])
            }
    }

    const getOfficeMarketHistorySellPricesTooltip = ({ quarterRegion }) => {

        const htmlString = ReactDOMServer.renderToStaticMarkup(
            <div style={{ fontSize: 14, padding: 5 }}>
                <div >
                    {`${quarterRegion[0].trimestre}º. ${translateText("Trim", language, translations, userCountry)} de ${quarterRegion[0].ano}`}
                </div>
                <div>
                    {`${translateText("Valor médio de venda transacionado no trimestre", language, translations, userCountry)} (${getCoinCountryLabel(buildingCountry)}/m²): ${formatNumber(quarterRegion[0].vmve, 2)}`}
                </div>
                <div>
                    {`Foram consideradas ${quarterRegion[0].countVMVE} transações em ${quarterRegion[0].countBuildings} edifícios.`}
                </div>
                <div>
                    {`${quarterRegion[0].transactionsLabel}`}
                </div>
            </div>
        );

        return htmlString
    }

    const getOfficeHistorySellPricesTooltip = ({ quarterBuilding }) => {

        if(quarterBuilding.length==0) return ''

        const htmlString = ReactDOMServer.renderToStaticMarkup(
            <div style={{ fontSize: 14, padding: 5 }}>
                <div >
                {`${quarterBuilding[0].trimestre}º. ${translateText("Trim", language, translations, userCountry)} de ${quarterBuilding[0].ano}`}
                </div>
                <div>
                    {`${translateText("Valor médio de venda transacionado no edifício", language, translations, userCountry)}: ${formatNumber(quarterBuilding[0].vmve, 2)}`}
                </div>
            </div>

        );

        return htmlString
    }

    const getMinValue = (data) => {
        if(data.length > 0){
            let numbers = data.map(function(item) {return item.vmve});
            return Math.min.apply(Math, numbers)
        }else{
            return 0;
        }
    }
    
    const getMaxValue = (data) => {
        if(data.length > 0){
            let numbers = data.map(function(item) {return item.vmve});
            return Math.max.apply(Math, numbers)
        }else{
            return 0;
        }
    }

    const handleZoomChart = () => {
        const opt = {...options};        
        opt.chartArea.left = 70;
        opt.chartArea.top = 50;
        
        showDialog({
            component: <Chart
                chartType="ComboChart"
                data={historyData}
                options={opt}
                width={"100%"}
                height={445}
            />,
            showCancelButton: false,
            showConfirmButton: false,
            handleConfirm: () => closeDialog()
        })
    }

    return (
        <LoadComponent isLoading={load}>
            {historyData.length > 0 && 
                <div style={{ position: 'relative'}}>
                    <ZoomInIcon style={styles.iconZoom} onClick={handleZoomChart} />
                    <Chart
                        chartType="ComboChart"
                        data={historyData}
                        options={options}
                        width={"100%"}
                        height={280}
                    />
                </div>
            } 

            { historyData.length == 0 && 
                <div style={styles.emptyData}>
                    {translateText("Sem dados para montar gráfico", language, translations, userCountry)}
                </div>
            }
        </LoadComponent>
    )
}

const styles = {
    title: {
        fontSize: "14px",
        fontWeight: "600",
        color: "#7a7b7c"
    },
    emptyData:{
        textAlign: "center",
    },
    iconZoom: {
        position: 'absolute', 
        right: 10, 
        top: 10, 
        zIndex: 1, 
        cursor: "pointer", 
        width: 30, 
        height: 30,
        color: "#568C62"
    }
}